import React, {Component} from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import {getNumericValue} from '../../../../../common/util/fieldsValidation';
import {colors} from '../../../../../common/constants/colors';
import _ from 'lodash';

class LineChartInSalesByAgencies extends Component {
  getDataKey() {
    const {data} = this.props;
    const firstElement = data.length ? data[0] : [];
    const hasAliasName = firstElement.hasOwnProperty('aliasName') ? 'aliasName' : 'name';
    return hasAliasName;
  }

  renderTooltip(totalAmount, {active, payload, label}) {
    if (!active) {
      return null;
    }

    const amount = payload[0].value;
    const percentage = (amount * 100) / totalAmount;

    return (
      <div className='sales-tooltip'>
        <p>{label}</p>
        <p>Ventas: {'$'}{getNumericValue(amount, 2)}</p>
        <p>Porcentaje: {getNumericValue(percentage, 0)}%</p>
      </div>
    );
  }

  render() {
    const {data} = this.props;
    const totalAmount = _.sumBy(data, 'amount');
    const dataKey = this.getDataKey();

    return (
      <ResponsiveContainer width='100%' height={500}>
        <LineChart
          data={data}
          margin={{'top': 15, 'right': 5, 'left': 20, 'bottom': 5}}
        >
          <XAxis dataKey={dataKey} />
          <YAxis />
          <CartesianGrid strokeDasharray='3 3' />
          <Tooltip content={this.renderTooltip.bind(this, totalAmount)} />
          <Legend />
          <Line
            type='monotone'
            dataKey='amount'
            stroke={colors[0]}
            activeDot={{'r': 6}}
            name='Ventas'
          />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default LineChartInSalesByAgencies;
